var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "80", height: "80", viewBox: "0 0 80 80", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "event-guests-outline-icon"
    ),
    React.createElement(
      "g",
      { transform: "translate(24 24)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(8 9.6)" },
        React.createElement("circle", { fill: "#222", cx: "13.6", cy: "1.6", r: "1.6" }),
        React.createElement("circle", { fill: "#222", cx: "1.6", cy: "1.6", r: "1.6" }),
        React.createElement("path", { d: "M0 8.81s1.713 3.576 7.794 3.572c6.081-.003 7.794-3.582 7.794-3.582", stroke: "#222", strokeLinecap: "round" })
      ),
      React.createElement("rect", { stroke: "#222", x: ".5", y: ".5", width: "31", height: "31", rx: "6.4" })
    )
  );
});


// WEBPACK FOOTER //
// ../public/images/icons/guests-outline.svg?react-svg